<template>
    <div>
        <text-heading sub>
            Lijsten
        </text-heading>
    </div>

    <chip-container>
        <chip-label
            v-for="list in lists"
            :key="list"
        >
            {{ list }}
        </chip-label>
    </chip-container>
</template>

<script setup lang="ts">
    import { ChipContainer, ChipLabel, TextHeading } from '@keyvue/one-ui';
    import { computed } from 'vue';

    const lists = computed(() => [
        'KeyVue-Emma',
        'KeyVue-Agenda',
        'KeyVue',
    ]);
</script>
